<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('serviceRequest.serviceRequestDate')
                }}</label>
                <a-date-picker
                  v-model="model.service_request_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  class="ts-w-full"
                ></a-date-picker>
                <div class="validate" v-if="errors.has('service_request_date')">
                  {{ errors.first('service_request_date') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('serviceRequest.serviceStatus')
                }}</label>
                <a-select
                  v-model="model.service_status"
                  :options="serviceStatus"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('service_status') }"
                  placeholder="Select"
                ></a-select>
                <div class="validate" v-if="errors.has('service_status')">
                  {{ errors.first('service_status') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  class="ts-mb-0 ts-font-robot"
                  :class="model.service_request_type_id == 1 ? 'required' : ''"
                  >{{ $t('serviceRequest.requestedBy') }}</label
                >
                <a-select
                  v-model="model.requested_by"
                  :options="customers"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('requested_by') }"
                  placeholder="Select"
                  @change="onChangeRequestBy"
                  @search="handleSearchCustomer"
                  :loading="customer_searching"
                ></a-select>
                <div class="validate" v-if="errors.has('requested_by')">
                  {{ errors.first('requested_by') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  class="ts-mb-0 ts-font-robot"
                  :class="model.service_request_type_id == 1 ? 'required' : ''"
                  >{{ $t('serviceRequest.product') }}</label
                >
                <a-select
                  v-model="model.product_id"
                  :options="products"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('product_id') }"
                  placeholder="Select"
                  @search="handleSearchProduct"
                  :loading="product_searching"
                  @change="onChangeProduct"
                ></a-select>
                <div class="validate" v-if="errors.has('product_id')">
                  {{ errors.first('product_id') }}
                </div>
              </div>
            </div>
            <div class="row" v-if="serialLists.length > 0">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('serviceRequest.serialNo')
                }}</label>
                <a-select
                  v-model="model.serial_no"
                  :options="serialLists"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('serial_no') }"
                  placeholder="Select"
                ></a-select>
                <div class="validate" v-if="errors.has('serial_no')">
                  {{ errors.first('serial_no') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('serviceRequest.remarks')
                }}</label>
                <textarea
                  v-model="model.remarks"
                  rows="3"
                  class="form-control"
                  placeholder="Note something here"
                ></textarea>
                <div class="validate" v-if="errors.has('remarks')">
                  {{ errors.first('remarks') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('serviceRequest.serviceRequestType')
                }}</label>
                <a-select
                  v-model="model.service_request_type_id"
                  :options="serviceRequestTypes"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{
                    'is-invalid': errors.has('service_request_type_id')
                  }"
                  placeholder="Select"
                ></a-select>
                <div
                  class="validate"
                  v-if="errors.has('service_request_type_id')"
                >
                  {{ errors.first('service_request_type_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('serviceRequest.feeType')
                }}</label>
                <a-select
                  v-model="model.fee_type_id"
                  :options="feeTypes"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('fee_type_id') }"
                  placeholder="Select"
                ></a-select>
                <div class="validate" v-if="errors.has('fee_type_id')">
                  {{ errors.first('fee_type_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  class="ts-mb-0 ts-font-robot"
                  :class="model.service_request_type_id == 1 ? 'required' : ''"
                  >{{ $t('serviceRequest.invoice') }}</label
                >
                <a-select
                  v-model="model.stock_out_id"
                  :options="invoices"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('stock_out_id') }"
                  placeholder="Select"
                  @change="onChangeInvoice"
                ></a-select>
                <div class="validate" v-if="errors.has('stock_out_id')">
                  {{ errors.first('stock_out_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('serviceRequest.owner')
                }}</label>
                <a-select
                  v-model="model.owner"
                  :options="owners"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('owner') }"
                  placeholder="Select"
                ></a-select>
                <div class="validate" v-if="errors.has('owner')">
                  {{ errors.first('owner') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ts-checkbox
                  v-model="model.required_spare_part"
                  class="ts-font-robot"
                >
                  {{ $t('serviceRequest.requiredSparePart') }}
                </ts-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <PlannedMaintenance
              v-model="model"
              :validate="errors"
              v-if="model.service_request_type_id == 1 && !this.isUpdate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
            <ts-button :disabled="loading" @click.prevent="onCancel"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              :disabled="loading"
              @click.prevent="onSaveAddNew"
              outline
              color="primary"
              >{{ $t('saveAddNew') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              :disabled="loading"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              :disabled="loading"
              color="primary"
              @click.prevent="onUpdate"
            >
              {{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import PlannedMaintenance from './components/form/planned-maintenance.vue'
import { mapActions, mapState } from 'vuex'
import { isEmpty, debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'from',
  components: {
    PlannedMaintenance
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      customer_searching: false,
      product_searching: false,
      model: {
        service_request_id: null,
        service_request_no: null,
        service_request_date: moment().format('DD-MM-YYYY'),
        service_request_type_id: null,
        fee_type_id: null,
        requested_by: null,
        request_photo: null,
        service_status: 0,
        required_spare_part: false,
        input_source: 'W',
        product_id: null,
        stock_out_id: null,
        serial_no: null,
        owner: null,
        remarks: null,
        comment: null,
        planned_maintenance: []
      }
    }
  },
  created() {
    this.setEditData()
    this.getPreData({
      params: {},
      index: undefined
    })
    this.model.owner = this.$store.state.authUser.user.user_id
    this.errors = new Errors()
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', [
      'edit_data',
      'formViewDatas'
    ]),
    isUpdate() {
      return !isEmpty(this.edit_data)
    },
    serviceRequestTypes() {
      if (this.formViewDatas['serviceRequestTypes']) {
        return this.formViewDatas['serviceRequestTypes'].map(el => ({
          value: el.service_request_type_id,
          label: el.service_request_type,
          service_request_schedule: el.service_request_schedule
        }))
      }
      return []
    },
    feeTypes() {
      if (this.formViewDatas['feeTypes']) {
        return this.formViewDatas['feeTypes'].map(el => ({
          value: el.product_id,
          label: el.product_name_en
        }))
      }
      return []
    },
    owners() {
      if (this.formViewDatas['owners']) {
        return this.formViewDatas['owners'].map(el => ({
          value: el.user_id,
          label: el.employee_name_kh + '|' + el.employee_name_en
        }))
      }
      return []
    },
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
    invoices() {
      if (this.formViewDatas['invoices']) {
        return this.formViewDatas['invoices'].map(el => ({
          value: el.stock_out_id,
          label: el.invoice_no + '|' + el.stock_out_date,
          details: el.details.map(item => item.product_id),
          stock_out_date: el.stock_out_date,
          serial_list: el.details.flatMap(item => item.serial_list)
        }))
      }
      return []
    },
    products() {
      if (this.formViewDatas['products']) {
        if (this.model.service_request_type_id == 1) {
          return this.formViewDatas['products']
            .filter(p => p.is_warranty == true)
            .map(el => ({
              value: el.product_id,
              label: el.product_name_en
            }))
        } else {
          return this.formViewDatas['products'].map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))
        }
      }
      return []
    },
    serialLists() {
      if (this.model.stock_out_id && this.model.product_id) {
        let serial_list = this.invoices.find(
          el => el.value == this.model.stock_out_id
        ).serial_list

        return serial_list
          ? serial_list
              .filter(e => e.product_id == this.model.product_id)
              .map(s => ({
                value: s.serial_no,
                label: s.serial_no
              }))
          : []
      }
      return []
    },
    serviceStatus() {
      return [
        {
          label: 'Pending',
          value: 0
        },
        {
          label: 'Progressing',
          value: 1
        },
        {
          label: 'Completed',
          value: 2
        },
        {
          label: 'Cancel',
          value: 3
        }
      ]
    }
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', [
      'getFormViewModel',
      'store',
      'update'
    ]),
    handleSearchCustomer: debounce(async function(value) {
      this.customer_searching = true
      await this.getFormViewModel({
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value
        }
      })
      this.customer_searching = false
    }, 800),
    handleSearchProduct: debounce(async function(value) {
      this.product_searching = true
      let invoice = this.invoices.find(
        el => el.value == this.model.stock_out_id
      )
      let product_id = invoice ? invoice.details : null

      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          search_product: value,
          product_id: product_id
        }
      })
      this.product_searching = false
    }, 800),
    onChangeRequestBy(value) {
      this.model.stock_out_id = null
      this.model.product_id = null
      this.model.serial_no = null
      this.getFormViewModel({
        index: 'invoices',
        params: {
          fnName: 'invoices',
          customer_id: value
        }
      })
    },
    onChangeInvoice(value, option) {
      this.model.product_id = null
      this.model.serial_no = null
      if (value) {
        this.getFormViewModel({
          index: 'products',
          params: {
            fnName: 'products',
            product_id: option.data.props.details
          }
        })
      }
    },
    onChangeProduct(value, option) {
      this.model.serial_no = null
    },
    generatePlanned() {
      if (!this.isUpdate) {
        this.model.planned_maintenance = []
        if (
          this.model.service_request_type_id == 1 &&
          this.model.stock_out_id
        ) {
          let service_request_schedule = this.serviceRequestTypes.find(
            el => el.value == this.model.service_request_type_id
          ).service_request_schedule

          let invoice = this.invoices.find(
            el => el.value == this.model.stock_out_id
          )

          let stock_out_date = invoice ? invoice.stock_out_date : null

          service_request_schedule.forEach(el => {
            let newItem = {
              service_request_no: null,
              service_request_date: moment(stock_out_date, 'DD-MM-YYYY')
                .add(el, 'months')
                .format('DD-MM-YYYY'),
              service_request_type_id: this.model.service_request_type_id,
              fee_type_id: this.model.fee_type_id,
              requested_by: this.model.requested_by,
              request_photo: this.model.request_photo,
              service_status: this.model.service_status,
              required_spare_part: this.model.required_spare_part,
              input_source: this.model.input_source,
              product_id: this.model.product_id,
              stock_out_id: this.model.stock_out_id,
              serial_no: this.model.serial_no,
              owner: this.model.owner,
              remarks: this.model.remarks
            }
            this.model.planned_maintenance.push(newItem)
          })
        }
      }
    },
    async getPreData({ params, index }) {
      this.loading = true
      if (this.isUpdate) {
        params = {
          search_customer: this.model.requested_by,
          customer_id: this.model.requested_by,
          product_id: [this.model.product_id]
        }
      }
      await this.getFormViewModel({ index: index, params: params })
      this.loading = false
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.loading = true
      this.update({
        id: this.edit_data.service_request_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCancel() {
      this.clearInput()
      this.$emit('cancel')
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.service_request_id = this.edit_data.service_request_id
        this.model.service_request_no = this.edit_data.service_request_no
        this.model.service_request_date = this.edit_data.service_request_date
        this.model.service_request_type_id = this.edit_data.service_request_type_id
        this.model.fee_type_id = this.edit_data.fee_type_id
        this.model.requested_by = this.edit_data.requested_by
        this.model.request_photo = this.edit_data.request_photo
        this.model.service_status = this.edit_data.service_status
        this.model.required_spare_part = this.edit_data.required_spare_part
        this.model.input_source = this.edit_data.input_source
        this.model.product_id = this.edit_data.product_id
        this.model.stock_out_id = this.edit_data.stock_out_id
        this.model.serial_no = this.edit_data.serial_no
        this.model.owner = this.edit_data.owner
        this.model.remarks = this.edit_data.remarks
        this.model.comment = this.edit_data.comment
      }
    },
    clearInput() {
      this.model.service_request_id = null
      this.model.service_request_no = null
      this.model.service_request_date = moment().format('DD-MM-YYYY')
      this.model.service_request_type_id = null
      this.model.fee_type_id = null
      this.model.requested_by = null
      this.model.request_photo = null
      this.model.service_status = 0
      this.model.required_spare_part = false
      this.model.input_source = 'W'
      this.model.product_id = null
      this.model.stock_out_id = null
      this.model.serial_no = null
      this.model.owner = null
      this.model.remarks = null
      this.model.comment = null
      this.model.planned_maintenance = null
      this.$store.commit('serviceManagement/serviceRequest/SET_EDIT_DATA', {})
    }
  },
  watch: {
    'model.service_request_type_id': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.fee_type_id': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.service_status': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.requested_by': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.stock_out_id': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.product_id': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.serial_no': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.owner': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.remarks': debounce(function(search) {
      this.generatePlanned()
    }, 500),
    'model.required_spare_part': debounce(function(search) {
      this.generatePlanned()
    }, 500)
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
